import React, { useState } from "react";
import EdButton from "../../../generic/edButton";
import DeviceContext from "../../../service/indentifyDevice";
import Search from "../../../generic/search";
import PositionFilter from "./positionFilter";

if (DeviceContext().isDesktop) {
	require("../../../../../src/assets/scss/components/toc/position/positionUtilHeader/posUtilHeaderDsk.scss");
} else if (DeviceContext().isMobile) {
	require("../../../../../src/assets/scss/components/toc/position/positionUtilHeader/posUtilHeaderMob.scss");
} else {
	require("../../../../../src/assets/scss/components/toc/position/positionUtilHeader/posUtilHeaderTab.scss");
}

export interface PosUtilHdrProps {
	leftSideText: React.ReactElement; // data to show on the left part of util bar
	data: Array<Array<any>>; // data to be searched or filtered
	searchKey: string; // key on which search needs to be performed
	onDataFilter: (filteredData: any[], sText?: string, type?: string) => void; // returns filtered array after searching
	onSelectClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void; // event after clicking on select button
	onFilterClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void; // event after clicking on filter button
	onSearchClick: (hidePriNav: boolean) => void; // event after clicking on search button
	onToggleClick: (isToggleOn: boolean) => void;
}
export enum PosUtilHeaderState {
	NORMAL,
	FILTER,
	SEARCH
}
const PosUtilHdr: React.FC<PosUtilHdrProps> = (props) => {
	const [utilHeaderState, setUtilHeaderState] = useState(PosUtilHeaderState.NORMAL);

	const [isToggleOn, setIsToggleOn] = React.useState(true);

	function onSearchClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		setUtilHeaderState(PosUtilHeaderState.SEARCH);

		props.onSearchClick(true);
	}

	function onCancelClick() {
		setUtilHeaderState(PosUtilHeaderState.NORMAL);
		props.onSearchClick(false);
		props.onDataFilter(props.data, "", "search");
	}

	return (
		<div>
			{utilHeaderState === PosUtilHeaderState.NORMAL && (
				<div className="util_cont">
					<div>{props.leftSideText}</div>
					<div className="utils">
						{props.onSelectClick && (
							<span>
								{/* select button */}
								<EdButton
									value={
										<>
											<i className="select edel-icon-select vTextTop btn_icon" />
											<span>Select</span>
										</>
									}
									btnTyp="blue-link"
									onClick={props.onSelectClick}
								/>
							</span>
						)}
						<span>
							{/* filter button */}
							<PositionFilter
								data={props.data}
								onFilter={(filteredData: Array<Array<any>>) => {
									// remove all the empty arrays
									props.onDataFilter(filteredData.filter((data) => data.length));
								}}
								filterInputParams={{
									isToggleOn,
									showOpenOrderTgl: true
								}}
								tglClick={(value) => {
									setIsToggleOn(value);
									props.onToggleClick(value);
								}}
							/>
						</span>
						<span>
							<EdButton
								value={
									<>
										<i className="search edel-icon-search vTextTop btn_icon" />
										{!DeviceContext().isMobile && <span>Search</span>}
									</>
								}
								btnTyp="blue-link"
								onClick={onSearchClick}
								className="search_btn"
							/>
						</span>
					</div>
				</div>
			)}
			{utilHeaderState === PosUtilHeaderState.SEARCH && (
				<div className="util_cont search_active">
					{/* Search takes 1D array and returns 1D array
								So we need to convert it accordingly */}
					<Search
						searchList={props.data}
						searchKey={props.searchKey}
						onSearch={(data, sText, type) => props.onDataFilter(data, sText, type)}
						classname="active"
					/>
					<EdButton value="close" btnTyp="link" onClick={onCancelClick} />
				</div>
			)}
		</div>
	);
};

export default PosUtilHdr;
